import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'commonData';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_COMMON_DATA = createActionName('RECEIVE_COMMON_DATA');
export const SET_IS_STICKY_HEADER_VISIBLE = createActionName(
  'SET_IS_STICKY_HEADER_VISIBLE',
);

export function receiveCommonData(data) {
  return {
    type: RECEIVE_COMMON_DATA,
    payload: {
      ...data,
    },
  };
}

export function setIsStickyHeaderVisible(isStickyHeaderVisible) {
  return {
    type: SET_IS_STICKY_HEADER_VISIBLE,
    payload: isStickyHeaderVisible,
  };
}
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_COMMON_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case SET_IS_STICKY_HEADER_VISIBLE: {
      return {
        ...state,
        isStickyHeaderVisible: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
